import React from 'react'
import VendorCard from '../components/VendorCard'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


export default function Cart(props) {

    const [open, setOpen] = React.useState(false);

    function handleClickOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }
    const toHome = () => {
        props.history.push("/home/socialfeed")
    }

    const cartItems = [{
        vendor_name: "Amazon",
        img: "http://g-ec2.images-amazon.com/images/G/01/social/api-share/amazon_logo_500500._V323939215_.png",
        price: "$10.99 - $12.99",
        eta: "Delivery: 3 hours"
    },
    {
        vendor_name: "The Fresh Grocer",
        img: "https://www.recyclebank.com/media/catalog/product/cache/1/small_image/62defc7f46f3fbfc8afcd112227d1181/t/h/thefreshgrocer.jpg",
        price: "$14.99 - $16.99",
        eta: "Delivery: 1 hour"
    }]

    return (
        <div className="Cart">
            {cartItems.map(item => <VendorCard vendor={item.vendor_name} img={item.img} price={item.price} eta={item.eta} />)}
            <Button className="PlaceOrder" variant="contained" color="primary" onClick={handleClickOpen}> <i className="material-icons"> shopping_cart </i>Place Order</Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Purchase is confirmed"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Thank you for shopping with us!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={toHome} color="primary">
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        </div>



    )
}
